module.exports = __webpack_public_path__ + "img/kr-product-agency-card2-img1.9892ae0.png";